import React from "react";
import "./ThankyouStyles.scss";
import { Link } from "react-router-dom";
const Thankyou = () => {
  return (
    <div className='thanks-page'>
      <h1>Thank you</h1>
      <p>"Thanks for signing up to Breathing for Brassplayers. Be on the lookout for updates!"</p>
      <Link to='/' className='special-btn'>
        Home
      </Link>
    </div>
  );
};

export default Thankyou;
